import { useState } from "react"
const genres = [
    { label: "Rock / Indie", value: "ROCK_INDIE" },
    { label: "Pop", value: "POP" },
    { label: "Acoustic", value: "ACOUSTIC" },
    { label: "Hip-Hop / Grime", value: "HIPHOP_GRIME" },
    { label: "Electronic", value: "ELECTRONIC" },
    { label: "Reggae / Dub", value: "REGGAE_DUB" },
    { label: "Metal", value: "METAL" },
    { label: "Other", value: "OTHER" }
]

export const GenreDropdown = ({ value, onChange, placeholder = "Select a genre" }) => {
    const [isOpen, setIsOpen] = useState(false)

    const selectedGenre = genres.find(g => g.value === value)

    return (
        <div className="relative w-full max-w-xs">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="w-[64] bg-theme_clr2 text-white px-2 py-2 rounded-lg flex items-center justify-between hover:bg-theme_clr2 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
                <span className="text-sm">
                    {selectedGenre ? selectedGenre.label : placeholder}
                </span>
                <svg 
                    className={`w-5 h-5 transition-transform ${isOpen ? 'rotate-180' : ''}`} 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                >
                    <path 
                        strokeLinecap="round" 
                        strokeLinejoin="round" 
                        strokeWidth={2} 
                        d="M19 9l-7 7-7-7" 
                    />
                </svg>
            </button>

            {isOpen && (
                <>
                    <div
                        className="fixed inset-0 z-10"
                        onClick={() => setIsOpen(false)}
                    />
                    <div className="absolute z-20 mt-2 w-full bg-theme_clr1 rounded-lg shadow-xl overflow-hidden border border-slate-700">
                        <div className="max-h-64 overflow-y-auto">
                            {genres.map((genre) => (
                                <button
                                    key={genre.value}
                                    onClick={() => {
                                        onChange(genre.value)
                                        setIsOpen(false)
                                    }}
                                    className={`w-full text-left px-4 py-3 text-white text-sm hover:bg-theme_clr2 transition-colors ${
                                        value === genre.value ? 'bg-theme_clr2 font-medium' : ''
                                    }`}
                                >
                                    {genre.label}
                                </button>
                            ))}
                        </div>
                    </div>
                </>
            )}
        </div>
    )
}